import React from 'react';
import { useController } from 'react-hook-form';

// components
import MultiSelectDropdown from '../../../MultiSelectDropdown';
import FormFieldLabel from '../FormFieldLabel';
import FormFieldError from '../FormFieldError';
import FormFieldDescription from '../FormFieldDescription';

const MultiSelectDropdownField = ({ name, control, rules, label, description, ...props }) => {
    const {
        field: { value, onChange },
        fieldState: { error }
    } = useController({
        name,
        control,
        rules,
        defaultValue: []
    });

    return (
        <div className="FormField FormField--multiselect">
            <FormFieldLabel label={label} name={name} rules={rules} />
            <MultiSelectDropdown
                {...props}
                value={value || []}
                onChange={onChange}
                name={name}
            />
            {error ? (
                <FormFieldError error={error} />
            ) : (
                <FormFieldDescription description={description} />
            )}
        </div>
    );
};

export default MultiSelectDropdownField;
